import {Component, OnDestroy, OnInit} from '@angular/core';
import {OptionsPageBase} from '../../general/OptionsPageBase';
import {AppService} from '../../../services/app.service';

@Component({
	selector: 'app-tur-options',
	templateUrl: './tur-options.component.html',
	styleUrls: ['./tur-options.component.scss']
})
export class TurOptionsComponent extends OptionsPageBase implements OnInit, OnDestroy {

	theme: string = "tur";

	constructor(app: AppService) {
		super(app);
	}
}
